/**
 * A `datetime-local` input's value ("2026-10-01T18:00") and the instant it
 * means, in the browser's time zone (Conakry is UTC all year). The request
 * carries the instant as ISO 8601; the input never sees a time zone.
 */

const pad = (value: number) => String(value).padStart(2, "0");

/** An instant as a `datetime-local` value. */
export function toLocalInput(when: Date | string): string {
  const at = typeof when === "string" ? new Date(when) : when;
  return `${at.getFullYear()}-${pad(at.getMonth() + 1)}-${pad(at.getDate())}T${pad(at.getHours())}:${pad(at.getMinutes())}`;
}

/** A `datetime-local` value as an instant, or null when it isn't one. */
export function fromLocalInput(value: string): Date | null {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(value)) return null;
  const at = new Date(value);
  return Number.isNaN(at.getTime()) ? null : at;
}
